import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import TokenStorage from '../../utils/tokenStorage';
import Dialog from '../Dialogs/Dialog';

const RedirectRules = ({ CurrentUser, themeId, passwordExpired, redirectedToProfile, location }) => {
    const [shouldRedirectToProfile, setShouldRedirectToProfile] = React.useState(false);
    const [shouldRedirectToQuestions, setShouldRedirectToQuestions] = React.useState(false);

    const onDialogClose = () => {
        setShouldRedirectToProfile(true);
    };

    useEffect(() => {
        let authData = TokenStorage.get();
        let user = JSON.parse(authData);

        if (
            CurrentUser !== null &&
            typeof user.hasLogged === 'undefined' &&
            !user.autoLogin // Skip redirects for  AppSubmit and GuarantorSignature  pages
        ) {
            let isSecurityQuestionsValid = CurrentUser.IsSecurityQuesionsValid;
            let isUserProfileValid = CurrentUser.IsUserProfileValid;
            user.hasLogged = true;
            TokenStorage.save(user);

            if (isSecurityQuestionsValid && !isUserProfileValid) {
                setShouldRedirectToProfile(true);
            }
            if (!isSecurityQuestionsValid) {
                setShouldRedirectToQuestions(true);
            }
            // if (isSecurityQuestionsValid && isUserProfileValid) {
            //     setShouldRedirectToDetails(true);
            // }
        }
    }, [CurrentUser]);

    //disable redirection logic when using Brand Removing
    if (themeId) return null;

    const profileWarningDialog = (
        <Dialog
            onClose={onDialogClose}
            title="Please complete your profile information"
            show={true}
            closeButton="false"
            closeButtonText="Continue"
        ></Dialog>
    );

    const getShouldRedirectToProfile = () => {
        return (
            !passwordExpired &&
            !redirectedToProfile &&
            CurrentUser &&
            CurrentUser.profileIsNotComplete &&
            location.pathname !== '/resetpassword'
        );
    };

    const profileWarning = getShouldRedirectToProfile() ? profileWarningDialog : null;

    let redirectToProfile =
        shouldRedirectToProfile && !shouldRedirectToQuestions ? <Redirect to="/profile"></Redirect> : null;

    let redirectToQuestions = shouldRedirectToQuestions ? (
        <Redirect to="/profile/changesecurityquestions/"></Redirect>
    ) : null;

    // let redirectToDetails = shouldRedirectToDetails ? <Redirect to="/accounts"></Redirect> : '';

    return (
        <>
            {profileWarning}
            {redirectToProfile}
            {redirectToQuestions}
        </>
    );
};

export default connect((state) => {
    const { login, app } = state;
    return { ...login, ...app };
})(RedirectRules);
